import React, {PureComponent} from 'react';
import styles from './Icon.less';
import { FasMap } from './FasMap';

class Icon extends PureComponent {
	getFasColor(fasItem) {
		if (!fasItem["color"]) {
			return "";
		}
		return "text-" + fasItem.color;
	}

	render() {
		const {className, name, size = 16, ...props} = this.props;
		const { fasIcon } = styles;
		const fasItem = FasMap[name];

		const ui_version = window.shop_productgroup.ui_version || window.shop_productgroup_ui_version || '1.3';

		if (!fasItem) {
			return <i></i>;
		}

		let iconClass = ui_version === '2.0' ?
			['fas', fasItem.name, this.getFasColor(fasItem), fasIcon].join(' ')
			: ['icon' + size, name].join(' ');

		return <i className={[className, iconClass].join(' ')} {...props} />;
	}
}

export default Icon;